import { render, staticRenderFns } from "./MainNav.vue?vue&type=template&id=c12587c4&scoped=true&"
import script from "./MainNav.vue?vue&type=script&lang=js&"
export * from "./MainNav.vue?vue&type=script&lang=js&"
import style0 from "./MainNav.vue?vue&type=style&index=0&id=c12587c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12587c4",
  null
  
)

export default component.exports